import { Step } from "react-joyride";

export const tourStepsMatchingGame = (): Step[] => {
  const steps: Step[] = [
    {
      target: "h1",
      content:
        "Matching Game lets you connect words to their matches. Build a word list here, then start the game.",
      disableBeacon: true,
    },
    {
      target: ".game-instructions",
      content:
        "Type a word and click Add Word. Each word will appear on both sides of the board so you can draw a match.",
    },
    {
      target: ".add-words-form",
      content:
        "Add as many words as you want. Click the × next to a word to remove it before you start.",
    },
    {
      target: ".start-button",
      content:
        "Set an optional timer, or check No Time Limit. Then click Start Game. Drag from a word on the left to its match on the right.",
    },
  ];

  return steps;
};
